<!-- eslint-disable vue/require-v-for-key -->
<template>
    <div class="wrapper watchlist-page">
        <div>
            <div class="columns watchlist-content">
                <div class="column is-12-mobile is-9">
                    <div class="columns is-flex">
                        <div class="column is-6 is-align-self-center">
                            <back-button></back-button>
                        </div>
                    </div>
                    <div class="is-size-5 is-size-4-desktop has-text-weight-bold m-b-10 line-height-medium">Choose your top funds list and see it in our watchlist below</div>
                    <div class="m-b-20">( <a class="has-text-underline" href="/login"><strong>Login | Sign up</strong></a> to create your own watchlists )</div>
                    <div class="m-b-40">
                        <div class="m-b-10" v-for="(item, index) in topList" :key="index">
                            <a class="is-size-5 has-text-underline has-text-weight-bold top-fund-list-title" v-on:click="handleSelectTopFundsList(item)">{{item.title}}</a>
                        </div>
                    </div>
                    <div class="separation-line"></div>
                    <div id="scrollToMyFundLists" class="header-funds-list-selected text-align-center m-t-35" v-if="topFundsListSelected">
                        <h1 class="title-page is-size-5 is-size-4-desktop has-text-weight-bold">
                            {{ topFundsListSelected.title }}
                        </h1>
                        <div>{{ topFundsListSelected.desc }}</div>
                    </div>
                    <div class=""></div>
                    <div class="columns mt-3">
                        <div class="column is-12  is-hidden-mobile">
                            <div class="columns is-flex-mobile">
                                <div class="column is-6-mobile is-12">
                                    <div class="is-12 mt-1">
                                        <div class="is-flex is-flex-direction-row is-align-content-center filters-watchlist">
                                            <div class="is-flex is-flex-direction-column">
                                                <h2 class="is-size-5 is-size-5-desktop has-text-weight-bold is-white-space-nowrap mb-1">Sort by</h2>
                                                <div class="is-flex is-flex-direction-row is-align-content-center">
                                                    <div class="is-flex is-flex-direction-column">
                                                        <b-dropdown :disabled="selectedFund.length>0?false:true" aria-role="list" class="mr-3" v-model="sorting1">
                                                            <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                                                <span>{{sorting1.text ? sorting1.text : 'Level 1'}}</span>
                                                                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                            </button>
                                                            <b-dropdown-item aria-role="listitem" v-for="(i, index) in sortinglist1" :value="i" :key="index" :disabled="!i.sortable">{{i.text}}</b-dropdown-item>
                                                        </b-dropdown>
                                                        <div class="mt-2">
                                                            <b-select :disabled="selectedFund.length>0?false:true" class="sort-select-2" v-model="sortDir1" placeholder="-- select --">
                                                                <option v-for="(item, index) in sortingType1" :value="item.value" :key="index">{{item.text}}</option>
                                                            </b-select>
                                                        </div>
                                                    </div>
                                                    <div class="is-flex is-flex-direction-column">
                                                        <b-dropdown :disabled="!showSecondOption || selectedFund.length === 0" aria-role="list" class="mr-3" v-model="sorting2">
                                                            <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                                                <span>{{sorting2.text ? sorting2.text : 'Level 2'}}</span>
                                                                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                            </button>
                                                            <b-dropdown-item aria-role="listitem" v-for="(i, index) in sortinglist2" :value="i" :key="index" :disabled="!i.sortable">{{i.text}}</b-dropdown-item>
                                                        </b-dropdown>
                                                        <div class="mt-2">
                                                            <b-select :disabled="!showSecondOption || selectedFund.length === 0" class="sort-select-2" v-model="sortDir2" placeholder="-- select --">
                                                                <option v-for="(item, index) in sortingType2" :value="item.value" :key="index">{{item.text}}</option>
                                                            </b-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="is-flex is-flex-direction-column is-flex-grow-1 p-l-50">
                                                <div class="is-flex is-flex-direction-column is-align-content-center" style="width:fit-content">
                                                    <h2 class="is-size-5 is-size-5-desktop has-text-weight-bold is-white-space-nowrap mb-1" style="width:fit-content">For NTRs / OGC / 3Y SD display</h2>
                                                    <div class="is-flex is-flex-direction-column is-relative">
                                                        <b-dropdown aria-role="list" class="dropdown-display" v-model="displaying">
                                                            <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                                                <span>{{displaying.text ? displaying.text : 'Value'}}</span>
                                                                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                            </button>
                                                            <b-dropdown-item v-on:click="change_field(6,displaying)" aria-role="listitem" v-for="(i, index) in comboDisplay" :value="i" :key="index">{{i.text}}</b-dropdown-item>
                                                        </b-dropdown>
                                                        <b-tooltip  v-if="tooltipShow && selectedFund.length > 0" class="referral-tooltip" always html>
                                                            <div class="is-relative">
                                                                <span class="close-tooltip" @click="tooltipShow=false">X</span>
                                                                Use this menu to see in your watchlist <br>
                                                                > your funds position versus its category peers <br>
                                                                > the difference between your fund and the best fund in its category <br>
                                                                > the difference between your fund and the median fund in its category
                                                            </div>
                                                        </b-tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div ref="refWatchlistTable" class="columns is-relative">
                        <div v-if="!tooltipShow" class="is-flex is-justify-content-center pl-3 pr-2 is-align-items-center is-hidden-tablet m-b-10 p-t-5">
                            <p class="has-text-centered is-size-7-mobile grey-text-2"><img src="/img/h-scroll.svg" class="h-scroll-icon"> Swipe table to see more</p>
                        </div>
                        <div class="column is-12 px-0 p-r-15-tablet p-l-15-tablet">
                            <div class="scroll-table-wrapper distance-table overflow-x-auto">
                                <table class="watchlist-table alerts-table-1">
                                    <thead>
                                        <tr>
                                            <td>N</td>
                                            <td>ISIN</td>
                                            <td>CCY</td>
                                            <td>
                                                <div class="sprd-vs-title">SPRD VS</div>
                                            </td>
                                            <td v-for="num in 5" :key="num">
                                                <b-dropdown :scrollable="true" :max-height="isMobile()?400:300" :append-to-body="true" aria-role="list" class="attribute-dropdown">
                                                    <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                                        <span>{{selected_fs['selected_f' + num].code==='ChangeInPrice'?'1 Day Move':selected_fs['selected_f' + num].text}}</span>
                                                        <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                    </button>
                                                    <b-dropdown-item aria-role="listitem" v-for="(option, index) in current_fields" v-bind:value="option.ID" v-on:click="change_field(num,option)" :key="index">{{ option.text }}</b-dropdown-item>
                                                </b-dropdown>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                    <template  v-for="(i, index) in selectedFund">
                                        <tr v-bind:class="(index == 0)?'wh':''">
                                            <td class="full-column" colspan="9">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Top Funds List',params:{id:i.ISIN, text: convertURL(i.am_short || '')}}">
                                                            {{ i.FundBasicsName }}
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see Fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-bind:class="(index == 0)?'wh':''">
                                            <td><span>{{index+1}}</span></td>
                                            <td><span>{{i.ISIN}}</span></td>
                                            <td><span>{{i.CurrencyId}}</span></td>
                                            <td>
                                                <b-dropdown id="dropdown-sprd-vs" :scrollable="true" :max-height="isMobile()?400:300" :append-to-body="true" aria-role="list" class="attribute-dropdown">
                                                    <button class="button is-primary box-shadow-style-c" slot="trigger" slot-scope="{ active }">
                                                        <span class="dropdown-caption" :data-defaultBenchIsin="i.defaultbenchisin && listBenchmark.filter(item => item.ISIN === i.defaultbenchisin).length ? true : false" 
                                                        :data-bisin="i.defaultbenchisin && listBenchmark.filter(item => item.ISIN === i.defaultbenchisin).length ? i.defaultbenchisin : ''" :ref="'benchmark_' + i.ISIN">
                                                        {{i.defaultbenchisin 
                                                            ? listBenchmark.filter(item => item.ISIN === i.defaultbenchisin).length 
                                                                ? listBenchmark.filter(item => item.ISIN === i.defaultbenchisin)[0].description 
                                                                : 'Select benchmark' 
                                                            : 'Select benchmark'}}
                                                        </span>
                                                        <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                    </button>
                                                    <b-dropdown-item v-if="i.defaultbenchisin && listBenchmark.filter(item => item.ISIN === i.defaultbenchisin).length" aria-role="listitem" :id="'dropdown'+i.ISIN" class="active-default" v-on:click="changeBenchmark('benchmark_' + i.ISIN, i, 'dropdown'+i.ISIN)" v-bind:value="i.defaultbenchisin" :key="-1">{{listBenchmark.filter(item => item.ISIN === i.defaultbenchisin) ? listBenchmark.filter(item => item.ISIN === i.defaultbenchisin)[0].description : ''}}</b-dropdown-item>
                                                    <b-dropdown-item aria-role="listitem" v-for="(option, idx) in listBenchmark.filter(item => item.ISIN !== i.defaultbenchisin)" v-bind:value="option.ISIN" v-on:click="changeBenchmark('benchmark_' + i.ISIN, i, 'dropdown'+i.ISIN, option)" :key="idx">{{ option.description }}</b-dropdown-item>
                                                </b-dropdown>
                                            </td>
                                            <td v-for="n in 5" :key="n">
                                                <span  
                                                    :class="{red: i[selected_fs['selected_f'+n].code] < 0}" 
                                                    v-if="i[selected_fs['selected_f'+n].code]!=null || checkNTRs(selected_fs['selected_f'+n].code)">
                                                    <template v-if="checkNTRs(selected_fs['selected_f'+n].code)">
                                                        <div v-if="displaying.code === 'rank'">
                                                            <div  class="dark-text" v-if="i[displayFilter['rank' + selected_fs['selected_f'+n].code]] != null && i[displayFilter['num' + selected_fs['selected_f'+n].code]] != null">
                                                                {{ `${i[displayFilter['rank' + selected_fs['selected_f'+n].code]]} Out of ${i[displayFilter['num' + selected_fs['selected_f'+n].code]]}` }}
                                                            </div>
                                                            <div v-else style="color: #999">n/a</div>
                                                        </div>
                                                        <div v-else-if="displaying.code === 'best' || displaying.code === 'median'" :class="{ 'dark-text': i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]] == null || i[selected_fs['selected_f'+n].code] == null }">
                                                            <div :class="[
                                                                {red: i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]] < 0},
                                                                {'dark-text': i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]] > 0}
                                                                ]"
                                                                v-if="i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]] != null">
                                                                {{ Number(i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]]).toFixed(2) + '%' }}
                                                            </div>
                                                            <div v-else style="color: #999">n/a</div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="selected_fs['selected_f'+n].code == 'fundnetassetgbp'">
                                                            {{ currency("GBP", parseNA(i[selected_fs['selected_f'+n].code])) }}m
                                                        </template>
                                                        <template v-else>
                                                            <span v-if="selected_fs['selected_f'+n].code == 'IndexFund'" class="ws-style" :class="i[selected_fs['selected_f'+n].code] | numbersformat(selected_fs['selected_f'+n].code)">
                                                                {{ i[selected_fs['selected_f'+n].code] | numbersformat(selected_fs['selected_f'+n].code)}}
                                                            </span>
                                                            <span v-else-if="selected_fs['selected_f'+n].code == 'LegalStructure'">
                                                                {{ i[selected_fs['selected_f'+n].code] | stringFormat(selected_fs['selected_f'+n].code)}}
                                                            </span>
                                                            <span v-else>
                                                                {{ i[selected_fs['selected_f'+n].code] | numbersformat(selected_fs['selected_f'+n].code)}}{{selected_fs['selected_f'+n].code | findUnit}}
                                                            </span>
                                                        </template>
                                                    </template>
                                                </span>
                                                <span v-else style="color: #999">n/a</span>
                                                <div v-show="displaying.code == 'value' && ['CumulativeTotalReturn1Year', 'CumulativeTotalReturnTD', 'TotalReturn3Years', 'TotalReturn5Years'].includes(selected_fs['selected_f'+n].code)">
                                                    <span 
                                                        :id="i.ISIN + 'benchmark_f' + n"
                                                        :ref="i.ISIN + 'benchmark_f' + n"
                                                        style="background-color: rgb(255, 254, 0);"
                                                    ></span>
                                                </div>
                                            </td>
                                            <td>
                                                <buttons :class="'btn-small'" :isAlert="false" :isDeleteFund="false" :isLogin="true" :ISIN="i.ISIN" :fundId="i.fund_id" :fund_data="i"/>
                                            </td>
                                        </tr>
                                    </template>
                                        <tr v-if="selectedFund.length===0" class="wh">
                                            <td class="full-column p-4 " colspan="9">
                                                <div class="has-text-centered">{{noAvailabledFund}}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <a v-if="topFundsListSelected" class="has-text-underline source-link" :href="topFundsListSelected.url" target="_blank">Source</a>
                        </div>
                    </div>
                    <div class="columns is-mobile">
                        <div class="column is-12-tablet disclaimer">
                            <Disclaimer />
                        </div>
                    </div>
                </div>
                <div ref="subRight_before" class="column is-12-mobile is-3-widescreen banner-right">
                    <div class="banner-on-top" ref="subRight">
                        <AdsGoogle />
                    </div>
                </div>

            </div>
        </div>

        <b-modal
            v-model="isCardModalActive"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Example Modal"
            aria-modal>
            <template >
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">SORT BY</p>
                        <button
                            type="button"
                            class="delete"
                            @click="isCardModalActive=false"/>
                    </header>
                    <section class="modal-card-body">
                        <ul class="sort-links is-justify-content-flex-start">
                            <li>
                                <div class="columns px-3 mt-2">
                                    <div>
                                        <label class="mb-2 is-block">Level 1</label>
                                        <b-select
                                            :disabled="selectedFund.length > 0 ? false : true"
                                            label="Level 1"
                                            class="sort-select-1"
                                            v-model="sorting1"
                                            expanded
                                            style="min-width:145px"
                                            placeholder="-- select --"
                                        >
                                            <option
                                                v-on:click="getTopListFunds(topListFundId)"
                                                v-for="(i, index) in sortinglist1" :value="i" :key="index" :disabled="!i.sortable">
                                                {{ i.text }}
                                            </option>
                                        </b-select>
                                        <b-select class="sort-select-2" v-model="sortDir1" placeholder="-- select --">
                                            <option v-for="(item, index) in sortingType1" v-on:click="getTopListFunds(topListFundId)" :value="item.value" :key="index">{{item.text}}</option>
                                        </b-select>
                                    </div>
                                    <div class="ml-3 m-l-0-mobile" v-if="showSecondOption">
                                        <label class="mb-2 is-block">Level 2</label>
                                        <b-select
                                            :disabled="!showSecondOption"
                                            label="Level 2"
                                            class="sort-select-1"
                                            v-model="sorting2"
                                            expanded
                                            style="min-width:145px"
                                            placeholder="-- select --"
                                        >
                                            <option
                                                v-for="(i, index) in sortinglist2" :value="i" :key="index" :disabled="!i.sortable">
                                                {{ i.text }}
                                            </option>
                                        </b-select>
                                        <b-select :disabled="!showSecondOption" class="sort-select-2" v-model="sortDir2" placeholder="-- select --">
                                            <option v-for="(item, index) in sortingType2"  :value="item.value" :key="index">{{item.text}}</option>
                                        </b-select>
                                    </div>
                                </div>
                            </li>

                            <li class="mr-0">
                                <div class="m-t-45">
                                    <a class="clear-btn" @click="clearSorting(1)">Clear</a>
                                </div>
                                <div v-if="showSecondOption" class="m-t-100">
                                    <a class="clear-btn" @click="clearSorting(2)">Clear</a>
                                </div>
                            </li>
                        </ul>
                        <div class="is-flex is-justify-content-center">
                            <button
                                type="button"
                                class="button is-primary"
                                @click="isCardModalActive=false">Apply</button>
                        </div>
                    </section>
                </div>
            </template>
        </b-modal>
        <div class="mobile-filters-watchlist is-hidden-tablet">
            <a @click="isCardModalActive = true" >SORT</a>
        </div>
    </div>
</template>
<style scoped>
    .separation-line {
        width: 70%;
        height: 1px;
        margin: 0 auto;
        background-color: #bfbfbf;
    }
    .box-shadow-style-c {
        box-shadow: 0px 0px 0px 1px #ccc;
    }
    .dropdown-caption {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .source-link {
        display: block;
        margin-top: 12px;
    }
    .header-funds-list-selected {
        background-color: #00b0f0;
        color: #fff;
        padding: 8px 0 12px 0;
        margin: 0 17%;
        border-radius: 15px;
    }
    #dropdown-sprd-vs button {
        background-color: rgb(255, 254, 0) !important;
        &:hover {
            color: #000;
        }
    }
    .sprd-vs-title {
        background: yellow;
        color: black;
        padding: 5px 0;
        margin: 0 15px;
    }
    @media (max-width: 768px) {
        .top-fund-list-title {
            font-size: 20px !important;
        }
        .header-funds-list-selected {
            padding: 8px 15px 12px 15px;
            margin: 0 10%;
        }
    }
    .dropdown-display::v-deep .dropdown-trigger {
        width: 100%;
    }
    .dropdown-display::v-deep .dropdown-trigger .button  {
        width: 100%;
        justify-content: space-between;
    }
    .btn-disabled {
        pointer-events: none;
    }
    #dropdown-sprd-vs.btn-disabled button.btn-default,
    #dropdown-sprd-vs.btn-disabled button {
        background: #ccc !important;
        border: 1px solid #ccc;
    }
    ::v-deep .sort-select-2 .select {
        width: 100%;
    }
    ::v-deep .sort-select-2 .select select {
        width: calc(100% - 0.25rem) !important; 
    }
    .dropdown-item.is-active, .dropdown-item.active-default {
        background-color: #41bcea !important;
        color: #fff !important;
    }
    
    ::v-deep .b-tooltip .tooltip-trigger {
        font-size: 20px;
        padding: 20px;
        font-weight: 700;
        background: #ff0;
        border: 1px solid #153647;
        color: #153647;
        width: fit-content;
        white-space: inherit;
        line-height: 1.2;
        box-shadow: 0 1px 2px 1px rgba(0,1,0,.2);
        border-radius: 6px;
    }
    ::v-deep .tooltip-content {
        display: none;
    }
    .referral-tooltip {
        position: absolute;
        top: calc(100% + 10px);
        z-index: 11;
        right: 50%;
        width: 220%;
        transform: translateX(50%);
    }
    ::v-deep .b-tooltip .tooltip-trigger:before {
        border-top-color: #4855da;
        top: auto;
        bottom: 100%;
        border-bottom: 10px solid #4855da;
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        right: auto;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        position: absolute;
        content: "";
        pointer-events: none;
        z-index: 38;
    }
    .close-tooltip {
        position: absolute;
        right: 0;
        top: -10px;
        cursor: pointer;
    }
    @media (max-width: 768px) {
        .distance-table {
            margin-left: 0 !important;
            width: 100% !important;
        }
    }
</style>

<script>
import axios from "axios";
import BackButton from '@/components/BackButton.vue';
import commonMixin from "@/mixins/commonMixin";
import bannerMixin from "@/mixins/bannerMixin";
import Buttons from '@/components/Buttons.vue';
import compositeMixin from "@/mixins/compositeMixin";
import Disclaimer from "@/components/Disclaimer"
import AdsGoogle from '@/components/AdsGoogle.vue';
export default {
  components: { BackButton, Buttons, Disclaimer, AdsGoogle },
    name: 'TopFunList',
    props: {

    },
    data(){
        return{
            tooltipShow: true,
            listBenchmark: [],
            topList: [],
            topFundsListSelected: null,
            currentWatchlist: {},
            selectedFund: [],
            isModalCreatedWatchlist: false,
            isModalEditWatchlist: false,
            sorting1: {},
            sorting2: {},
            showSecondOption: '',
            isCardModalActive: false,
            watchlistLoading: false,
            sortinglist1:[],
            sortinglist2: [],
            sortinglist: [
                {
                    code: 'FundBasicsName',
                    sortable: true,
                    text: 'Fund Name',
                    defaultSort: 'ASC'
                },
                {
                    code: 'PriceCurrency',
                    sortable: true,
                    text: 'Ccy',
                    defaultSort: 'DESC'
                },
                { text: 'Net Assets', code: 'fundnetassetgbp', sortable: true, defaultSort: 'DESC'},
                { text: 'Yield', code: 'yield12m', sortable: true, defaultSort: 'DESC'},
                { text: 'Premium/Discount', code: 'discounttoNAV', sortable: true, defaultSort: 'ASC'},
                { text: 'OGC', code: 'ongoingchargecomp', sortable: true, defaultSort: 'ASC'},
                { text: 'Risk Rating', code: 'riskrating_6M', sortable: true, defaultSort: 'ASC'},
                { text: 'Price', code: 'NAVorClosePrice', sortable: true, defaultSort: 'DESC'},
                { text: 'CCY Hedged', code: 'currencyhedged_all', sortable: true, defaultSort: 'DESC'},
                { text: '3Y SD', code: 'standarddev36m', sortable: true, defaultSort: 'ASC'},
                { text: 'NTR YTD', code: 'CumulativeTotalReturnTD' , sortable: true, defaultSort: 'DESC'},
                { text: 'NTR 1Y', code: 'CumulativeTotalReturn1Year', sortable: true, defaultSort: 'DESC'},
                { text: 'NTR 3Y', code: 'TotalReturn3Years', sortable: true, defaultSort: 'DESC'},
                { text: 'NTR 5Y', code: 'TotalReturn5Years', sortable: true, defaultSort: 'DESC'},
                { text: 'Style', code: 'IndexFund', sortable: true, defaultSort: 'ASC'},
                { text: 'Structure', code: 'LegalStructure', sortable: true, defaultSort: 'ASC'},
                { text: 'Asset Manager', code: 'am_short', sortable: true, defaultSort: 'DESC'},
                { text: 'Category', code: 'morningstarcategories', sortable: true, defaultSort: 'ASC'},
                { text: '1 Day Move', code: 'ChangeInPrice', sortable: false, defaultSort: 'DESC'},
                { text: '3Y Sharpe', code: 'sharperatio3Y', sortable: true, defaultSort: 'ASC'},
            ],
            displayFilter: {
                bestCumulativeTotalReturnTD: 'bestNTRYTD',
                bestCumulativeTotalReturn1Year: 'bestNTR1Y',
                bestTotalReturn3Years: 'bestNTR3Y',
                bestTotalReturn5Years: 'bestNTR5Y',
                medianCumulativeTotalReturnTD: 'medianNTRYTD',
                medianCumulativeTotalReturn1Year: 'medianNTR1Y',
                medianTotalReturn3Years: 'medianNTR3Y',
                medianTotalReturn5Years: 'medianNTR5Y',
                rankCumulativeTotalReturnTD: 'rankfundsntrytd',
                rankCumulativeTotalReturn1Year: 'rankfundsntr1y',
                rankTotalReturn3Years: 'rankfundsntr3y',
                rankTotalReturn5Years: 'rankfundsntr5y',
                numCumulativeTotalReturnTD: 'numfundsNTRYTD',
                numCumulativeTotalReturn1Year: 'numfundsNTR1Y',
                numTotalReturn3Years: 'numfundsNTR3Y',
                numTotalReturn5Years: 'numfundsNTR5Y',
                numongoingchargecomp: 'numfundsOGC',
                bestongoingchargecomp: 'bestOGC',
                medianongoingchargecomp: 'medianOGC',
                rankongoingchargecomp: 'rankfundsogc',
                numstandarddev36m: 'numfunds3YSD',
                beststandarddev36m: 'best3YSD',
                medianstandarddev36m: 'median3YSD',
                rankstandarddev36m: 'rankfunds3ysd',
            },
            displaying: {
                code: 'value',
                text: 'Value',
            },
            comboDisplay: [{
                code: 'value',
                text: 'Value',
            },{
                code: 'rank',
                text: 'Position Within Category',
            },{
                code: 'best',
                text: 'Spread To Category Best',
            },{
                code: 'median',
                text: 'Spread To Category Median',
            },
            ],
            sortingType1: '',
            sortingType2: [
                { value: 'DESC', text: 'Z-A'},
                { value: 'ASC', text: 'A-Z'}
            ],
            noAvailabledFund: "Select a top list from above.",
            sortDir1: '',
            sortDir2: 'ASC',
            // currencyNative : "",
            selected_fs: {
                selected_f1 : { text: 'NTR YTD', code: 'CumulativeTotalReturnTD'},
                selected_f2 : { text: 'NTR 1Y', code: 'CumulativeTotalReturn1Year'},
                selected_f3 : { text: 'NTR 3Y', code: 'TotalReturn3Years'},
                selected_f4 : { text: 'NTR 5Y', code: 'TotalReturn5Years'},
                selected_f5 : { text: 'Category', code: 'morningstarcategories'},
            },
            benchmark: {
                CumulativeTotalReturnTD: 'benchmarkTD',
                CumulativeTotalReturn1Year: 'benchmark1Y',
                TotalReturn3Years: 'benchmark3Y',
                TotalReturn5Years: 'benchmark5Y'
            },
            available_fields : [
                { text: 'Net Assets', code: 'fundnetassetgbp', sortable: true, defaultSort: 'DESC'},
                { text: 'Yield', code: 'yield12m', sortable: true, defaultSort: 'DESC'},
                { text: 'Premium/Discount', code: 'discounttoNAV', sortable: true, defaultSort: 'ASC'},
                { text: 'OGC', code: 'ongoingchargecomp', sortable: true, defaultSort: 'ASC'},
                { text: 'Risk Rating', code: 'riskrating_6M', sortable: true, defaultSort: 'ASC'},
                { text: 'Price', code: 'NAVorClosePrice', sortable: true, defaultSort: 'DESC'},
                { text: 'CCY Hedged', code: 'currencyhedged_all', sortable: true, defaultSort: 'DESC'},
                { text: '3Y SD', code: 'standarddev36m', sortable: true, defaultSort: 'ASC'},
                { text: 'NTR YTD', code: 'CumulativeTotalReturnTD', sortable: true, defaultSort: 'DESC'},
                { text: 'NTR 1Y', code: 'CumulativeTotalReturn1Year', sortable: true, defaultSort: 'DESC'},
                { text: 'NTR 3Y', code: 'TotalReturn3Years', sortable: true, defaultSort: 'DESC'},
                { text: 'NTR 5Y', code: 'TotalReturn5Years', sortable: true, defaultSort: 'DESC'},
                { text: 'Style', code: 'IndexFund', sortable: true, defaultSort: 'ASC'},
                { text: 'Structure', code: 'LegalStructure', sortable: true, defaultSort: 'ASC'},
                { text: 'Asset Manager', code: 'am_short', sortable: true, defaultSort: 'DESC'},
                { text: 'Category', code: 'morningstarcategories', sortable: true, defaultSort: 'ASC'},
                { text: '1 Day Move', code: 'ChangeInPrice', sortable: true, defaultSort: 'DESC'},
                { text: '3Y Sharpe', code: 'sharperatio3Y', sortable: true, defaultSort: 'ASC'},
            ],
            predefinedSortList: [
                {code: "CumulativeTotalReturnTD", defaultSort: 'DESC'},
                {code: "CumulativeTotalReturn1Year", defaultSort: 'DESC'},
                {code: "TotalReturn3Years", defaultSort: 'DESC'},
                {code: "TotalReturn5Years", defaultSort: 'DESC'},
                {code: "FundBasicsName", defaultSort: 'ASC'},
                {code: "fundnetassetgbp", defaultSort: 'DESC'},
                {code: "yield12m", defaultSort: 'DESC'},
                {code: "ongoingchargecomp", defaultSort: 'ASC'},
                {code: "years_since_launch", defaultSort: 'DESC'},
                {code: "manager tenure", defaultSort: 'DESC'},
                {code: "NumberOfHolding", defaultSort: 'DESC'},
                {code: "standarddev36m", defaultSort: 'ASC'},
                {code: "premium/discount to NAV", defaultSort: 'ASC'},
                {code: "CompanyBasicsName", defaultSort: 'ASC'},
                {code: "LegalStructure", defaultSort: 'ASC'},
                {code: "ETF / non ETF", defaultSort: 'ASC'},
                {code: "riskrating_6M", defaultSort: 'ASC'},
                {code: "morningstarcategories", defaultSort: 'ASC'},
                {code: "IndexFund", defaultSort: 'ASC'},
                {code: "am_short", defaultSort: 'DESC'},
                {code: "ongoingchargecomp", defaultSort: 'ASC'},
            ],
            current_fields: [],
            topListFundId: '',
        }
    },
    mixins: [commonMixin, compositeMixin, bannerMixin],
    computed: {
    },
    watch: {
        sorting1: function(value) {
            const self = this;
            let sortListCurrent = this.sortinglist.filter(
                el => Object.values(self.selected_fs).find((element) => element.code == el.code) 
                || ["FundBasicsName", "PriceCurrency"].includes(el.code)
            )
            this.sortinglist1 = sortListCurrent;
            if (value.code === 'CompanyBasicsName' ||
                    value.code === 'LegalStructure' ||
                    value.code === 'am_short' ||
                    value.code === 'ETF / non ETF' ||
                    value.code === 'riskrating_6M' ||
                    value.code === 'IndexFund' ||
                    value.code === 'FundBasicsName' ||
                    value.code === 'PriceCurrency' ||
                    value.code === 'morningstarcategories'
                ) {
                    this.showSecondOption = true
                    this.sortingType1 = [
                        { value: 'DESC', text: 'Z-A'},
                        { value: 'ASC', text: 'A-Z'}
                    ]
                } else {
                    this.showSecondOption = false
                    this.sortingType1 = [
                        { value: 'DESC', text: 'High to Low'},
                        { value: 'ASC', text: 'Low to high'},
                    ]
                    this.clearSorting(2)
                }
                this.sortDir1 = value.defaultSort;

            if(Object.keys(value).length !== 0) {
                this.sortinglist2 = sortListCurrent.filter(el => el.code !== value.code)
            }
            this.topListFundId && this.getTopListFunds(this.topListFundId)
        },
        sorting2: function(value) {
            const self = this;
            let sortListCurrent = this.sortinglist.filter(
                el => Object.values(self.selected_fs).find((element) => element.code == el.code) 
                || ["FundBasicsName", "PriceCurrency"].includes(el.code)
            )
            if (value.code === 'CompanyBasicsName' ||
                    value.code === 'LegalStructure' ||
                    value.code === 'am_short' ||
                    value.code === 'ETF / non ETF' ||
                    value.code === 'riskrating_6M' ||
                    value.code === 'IndexFund' ||
                    value.code === 'FundBasicsName' ||
                    value.code === 'PriceCurrency' ||
                    value.code === 'morningstarcategories'
                ) {
                    this.sortingType2 = [
                        { value: 'DESC', text: 'Z-A'},
                        { value: 'ASC', text: 'A-Z'}
                    ]
                } else {
                    this.sortingType2 = [
                         { value: 'DESC', text: 'High to Low'},
                        { value: 'ASC', text: 'Low to high'},
                    ]
                }

            this.sortDir2 = value.defaultSort;

            if(Object.keys(value).length !== 0) {
                this.sortinglist1 = sortListCurrent.filter(el => JSON.stringify(el) !== JSON.stringify(value))
            }
            this.topListFundId && this.getTopListFunds(this.topListFundId)
        },
        sortDir1: function() {
            this.topListFundId && this.getTopListFunds(this.topListFundId)
        },
        sortDir2: function() {
            this.topListFundId && this.getTopListFunds(this.topListFundId)
        }
    },
    filters: {
        numbersformat(labelValue, code){
            const typeText = ['morningstarcategories', 'am_short', 'LegalStructure', 'IndexFund', 'riskrating_6M', 'NAVorClosePrice'];
            const typeIndexFund = ['IndexFund'];
            const typeHedged = ['currencyhedged_all'];

            if(typeHedged.includes(code)) return labelValue ? 'Yes' : 'No'
            else if(typeIndexFund.includes(code)) return labelValue ? 'Passive' : 'Active'
            else if(typeText.includes(code)) return labelValue;
            else return parseFloat(labelValue).toFixed(2)
        },
        stringFormat(code){
            if ( code == 'IT'|| code == 'OEIC'|| code == 'SICAV' || code == 'UT') {
                return code
            } else {
                let matches = code.match(/\b(\w)/g)
                let acronym = matches.join('')
                return acronym
            }

        },
        findUnit(code) {
            const unitPercent = ['yield12m', 'discounttoNAV', 'ongoingchargecomp', 'standarddev36m', 'CumulativeTotalReturnTD', 'CumulativeTotalReturn1Year', 'TotalReturn3Years', 'TotalReturn5Years', 'ChangeInPrice'];
            if(unitPercent.includes(code)) return '%';
        }
    },
    methods:{
        handleSelectTopFundsList(item) {
            if (item && item.id != this.topListFundId) {
                this.topFundsListSelected = item;
                this.getTopListFunds(item.id, true);
            }
        },
        changeBenchmark(id, isin, dropdownId, bmark) {
            if (bmark) {
                this.$refs[id][0].textContent = bmark.description;
                this.$refs[id][0].dataset.bisin = bmark.ISIN;
                this.$refs[id][0].dataset.defaultbenchisin = false;
                for(let n = 1; n <= 5; n++) {
                    if ([
                            'CumulativeTotalReturn1Year', 
                            'CumulativeTotalReturnTD', 
                            'TotalReturn3Years', 
                            'TotalReturn5Years'
                        ].includes(this.selected_fs['selected_f'+n].code)) {
                        let $el = this.$refs[isin.ISIN + 'benchmark_f' + n][0];
                        if (isin[this.selected_fs['selected_f'+n].code] == null) {
                            $el.textContent =  '';
                        } else {
                            let $el = this.$refs[isin.ISIN + 'benchmark_f' + n][0];
                            let benchmarkValue = parseFloat(isin[this.selected_fs['selected_f'+n].code] - bmark[this.benchmark[this.selected_fs['selected_f'+n].code]]);
                            if (benchmarkValue > 0) {
                                $el.classList.remove("red");
                                $el.classList.add("dark-text");
                            } else {
                                $el.classList.remove("dark-text");
                                $el.classList.add("red");
                            }
                            $el.textContent =  benchmarkValue.toFixed(2) + '%';
                        }
                        
                    }
                }
            } else {
                this.$refs[id][0].textContent = isin.benchmark;
                this.$refs[id][0].dataset.bisin = isin.defaultbenchisin;
                this.$refs[id][0].dataset.defaultbenchisin = true;
                for(let n = 1; n <= 5; n++) {
                    if (
                        [
                            'CumulativeTotalReturn1Year', 
                            'CumulativeTotalReturnTD', 
                            'TotalReturn3Years', 
                            'TotalReturn5Years'
                        ].includes(this.selected_fs['selected_f'+n].code)) {
                        
                        let $el = this.$refs[isin.ISIN + 'benchmark_f' + n][0];
                        let benchmarkValue = parseFloat(isin[this.selected_fs['selected_f'+n].code] - isin[this.benchmark[this.selected_fs['selected_f'+n].code]]);
                        if (benchmarkValue > 0) {
                            $el.classList.remove("red");
                            $el.classList.add("dark-text");
                        } else {
                            $el.classList.remove("dark-text");
                            $el.classList.add("red");
                        }
                        $el.textContent =  benchmarkValue.toFixed(2) + '%';
                    }
                }
            }
            setTimeout(function(){
                document.getElementById(dropdownId).classList.remove('active-default');
            }, 500)
            
        },
        async updateBenchmark(){
            let funds = await this.selectedFund;
            for (var i = 0; i < funds.length; i++ ) {
                let fund = funds[i];
                let benchmarkIsin = this.$refs['benchmark_' + fund.ISIN][0];
                for (let n = 1; n <= 5; n++) {
                    if (['CumulativeTotalReturn1Year', 'CumulativeTotalReturnTD', 'TotalReturn3Years', 'TotalReturn5Years']
                        .includes(this.selected_fs['selected_f'+n].code)) {
                        let $el = this.$refs[fund.ISIN + 'benchmark_f' + n][0];
                        if (fund[this.selected_fs['selected_f'+n].code] == null) {
                            $el.textContent = '';
                        } else {
                            let benchmarkValueOrigin = fund[this.benchmark[this.selected_fs['selected_f'+n].code]];
                            if (!benchmarkIsin.dataset.defaultbenchisin && benchmarkIsin.dataset.bisin) {
                                var listBenchmarkFilter = this.listBenchmark.filter($el => $el.ISIN == benchmarkIsin.dataset.bisin)[0];
                                benchmarkValueOrigin = listBenchmarkFilter[this.benchmark[this.selected_fs['selected_f'+n].code]];
                            }
                            if ($el) {
                                if (fund.defaultbenchisin) {
                                    let benchmarkValue = parseFloat(fund[this.selected_fs['selected_f'+n].code] - benchmarkValueOrigin);
                                    if (benchmarkValue > 0) {
                                        $el.classList.remove("red");
                                        $el.classList.add("dark-text");
                                    } else {
                                        $el.classList.remove("dark-text");
                                        $el.classList.add("red");
                                    }
                                    $el.textContent = benchmarkValue.toFixed(2) + '%';
                                } else {
                                    $el.textContent = '';
                                }
                            }
                        }
                        
                    }
                }
            }
        },
        async getBenchmark(){
            var self = this;
            await axios.get(`/comparebenchmark`)
                .then(async (response) => {
                    if (response) {
                        self.listBenchmark = response.data;
                    }
                })
                .catch(() => {});
        },
        async getTopList() {
            var self = this;
            await axios.get(`/top-funds-list/-1`)
                .then(async (response) => {
                    if (response && response.data.length) {
                        self.topList = response.data;
                    }
                })
                .catch(() => {});
        },
        async getTopListFunds(id, scrollToFundList){
            if (!id)
                return;
            this.$store.commit("topFundList/SET_TOP_FUNDS_LIST_ID", id);
            this.noAvailabledFund="Please wait..."
            if (!this.watchlistLoading) {
                this.watchlistLoading = true
                const self = this;
                this.topListFundId = id;
                this.selectedFund = [];
                await axios.post(`/top-lists-constituents/${id}`,{
                    order1: self.sorting1.code!=='' ? this.sorting1.code : undefined,
                    order2: self.sorting2.code!=='' ? this.sorting2.code : undefined,
                    dir1: self.sortDir1 ? self.sortDir1 : undefined,
                    dir2: self.sortDir2 ? self.sortDir2 : undefined
                }).then(async (response) => {
                    if (response) {
                        self.selectedFund = response.data.items || [];
                        self.updateBenchmark()
                        this.watchlistLoading = false;
                    }
                })
                .catch(() => {
                    this.watchlistLoading = false;
                });
                this.noAvailabledFund="Your Watchlist is currently empty."
                this.$store.commit('topFundList/SET_TOP_FUNDS_LIST', this.selectedFund)
                if (scrollToFundList && self.selectedFund.length) {
                    self.scrollToFundList();
                }
            }
            this.updateListDropdownBenchmark()
        },
        updateListDropdownBenchmark(){
            var updateBenmarkButton = true;
            for(let n = 1; n < 6; n++) {
                if ([
                    'CumulativeTotalReturn1Year', 
                    'CumulativeTotalReturnTD', 
                    'TotalReturn3Years', 
                    'TotalReturn5Years'
                ].includes(this.selected_fs['selected_f'+n].code)) {
                    updateBenmarkButton = false;
                    break;
                }
            }
            var list = document.querySelectorAll("#dropdown-sprd-vs");
            updateBenmarkButton = updateBenmarkButton || this.displaying.code !== "value";
            if (updateBenmarkButton) {
                for (let i = 0; i < list.length; ++i) {
                    list[i].classList.add('btn-disabled');
                }
            } else {
                for (let i = 0; i < list.length; ++i) {
                    list[i].classList.remove('btn-disabled');
                }
            }
        },
        scrollToFundList() {
            const scrollToFundListBtn = document.getElementById('scrollToMyFundLists');
            const positionY = scrollToFundListBtn.offsetTop - 70;
            window.scrollTo(0, positionY);
        },
        change_field(fid,obj){
            if (fid !== 6) {
                if (this.sorting1.code != obj.code) {
                    this.sorting1 = obj
                }
                if(fid==1){
                    this.selected_fs.selected_f1 = obj;
                }
                if(fid==2){
                    this.selected_fs.selected_f2 = obj;
                }
                if(fid==3){
                    this.selected_fs.selected_f3 = obj;
                }
                if(fid==4){
                    this.selected_fs.selected_f4 = obj;
                }
                if(fid==5){
                    this.selected_fs.selected_f5 = obj;
                }
            } else {
                this.updateListDropdownBenchmark()
            }
            this.filterAvailableField();
        },
        filterAvailableField() {
            if(this.available_fields && this.available_fields.length) {
                this.current_fields = this.available_fields.filter(el => el.code !== this.selected_fs.selected_f1.code
                && el.code !== this.selected_fs.selected_f2.code
                && el.code !== this.selected_fs.selected_f3.code
                && el.code !== this.selected_fs.selected_f4.code
                && el.code !== this.selected_fs.selected_f5.code)
            }
        },
        acronymSentence(str) {
            let matches = str.match(/\b(\w)/g)
            let acronym = matches.join('')
            return acronym
        },
        clearSorting(level) {
            switch(level) {
                case 1: {
                    this.sorting1 = {
                        code: 'FundBasicsName',
                        sortable: true,
                        text: 'Fund Name'
                    }
                    this.sortDir1 = 'DESC'
                }
                break;
                case 2: {
                    this.sorting2 = {}
                    this.sortDir2 = 'DESC'
                }
                break;
                default:
                break;
            }
        },
        checkNTRs(selected_f){
            let ar = [
                'CumulativeTotalReturnTD',
                'CumulativeTotalReturn1Year',
                'CumulativeTotalReturn3Years',
                'CumulativeTotalReturn5Years',
                'TotalReturn3Years',
                'TotalReturn5Years',
                'ongoingchargecomp',
                'standarddev36m'
            ];
            return ar.includes(selected_f) && this.displaying.code !== 'value'
        },
    },
    async created() {
        window.addEventListener('scroll', this.handleScroll);
        await this.getTopList();
        await this.getBenchmark();
        this.filterAvailableField();
        if (this.$store.state.topFundList.id) {
            var self = this;
            this.topFundsListSelected = this.topList.find( fund => fund.id === self.$store.state.topFundList.id);
            this.getTopListFunds(this.$store.state.topFundList.id, true)
        }
    },
    mounted() {
        if (!this.sorting1.text) {
            this.sorting1 = {
                code: 'FundBasicsName',
                sortable: true,
                text: 'Fund Name',
                defaultSort: 'ASC'
            }
            this.sortDir1 = this.sorting1.defaultSort;
        }
        document.querySelector('.watchlist-table').addEventListener('copy', (e) => {
            e.preventDefault();
        });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    metaInfo() {
        return {
            title: "Popular top funds | Pickafund",
            meta: [
                { name: 'description', content:  'The top funds to invest in preset within our watchlists for you to use'},
            ]
        }
    }
}

</script>




